export default __webpack_public_path__ + "static/media/Finalefrontcover.c053938f.jpg";